// extracted by mini-css-extract-plugin
module.exports = {"searchHeader":"VehicleRecallSearchPanel-module__searchHeader___14lxh","subHeader":"VehicleRecallSearchPanel-module__subHeader___cXfPZ"};